var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"star-rating"},_vm._l((5),function(i){return _c('div',{key:i,staticClass:"star"},[(i <= _vm.stars)?_c('icon',{staticClass:"icon",attrs:{"icon":"star-filled"}}):(_vm.half && i == _vm.stars + 1)?_c('icon',{staticClass:"icon",attrs:{"icon":"star-half"}}):_c('icon',{staticClass:"icon",attrs:{"icon":"star-empty"}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }